var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{class:[_vm.windowWidth<=500? 'hidden':''],staticStyle:{"width":"100px"},attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }